import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { get, map } from 'lodash'

import { MISSION_STATUS_BY_ORDER } from 'Reducers/Mission/const'
import { MISSION_STATUS_ENUM } from './../../../../shared/constants'

import { TimeLineWrapper } from './style'

const steps = {
  [MISSION_STATUS_ENUM.DRAFT]: {
    label: 'Draft',
    order: MISSION_STATUS_BY_ORDER.DRAFT,
    status: null,
  },
  [MISSION_STATUS_ENUM.AVAILABLE]: {
    label: 'Available',
    order: MISSION_STATUS_BY_ORDER.AVAILABLE,
    status: null,
  },
  [MISSION_STATUS_ENUM.BOOKED]: {
    label: 'Booked',
    order: MISSION_STATUS_BY_ORDER.BOOKED,
    status: null,
  },
  [MISSION_STATUS_ENUM.CHECKED_IN]: {
    label: 'Checked-In',
    order: MISSION_STATUS_BY_ORDER.CHECKEDIN,
    status: null,
  },
  [MISSION_STATUS_ENUM.UNDER_REVIEW]: {
    label: 'Under Review',
    order: MISSION_STATUS_BY_ORDER.UNDER_REVIEW,
    status: null,
  },
  [MISSION_STATUS_ENUM.COMPLETED]: {
    label: 'Completed',
    order: MISSION_STATUS_BY_ORDER.COMPLETED,
    status: null,
  },
  [MISSION_STATUS_ENUM.CANCELLED]: {
    label: 'Cancelled',
    order: MISSION_STATUS_BY_ORDER.CANCELLED,
    status: null,
  },
  [MISSION_STATUS_ENUM.PAID]: {
    label: 'Paid',
    order: MISSION_STATUS_BY_ORDER.PAID,
    status: null,
  },
}

const createStatusClassName = (
  missionStatusName,
  statusName,
  missionStatusOrder,
  statusOrder,
) => {
  if (missionStatusName === MISSION_STATUS_ENUM.PAID) {
    return 'done'
  }
  if (missionStatusName === statusName) {
    return 'active'
  } else if (missionStatusOrder > statusOrder) {
    return 'done'
  }
  return null
}

const mapSteps = mission =>
  map(steps, (stepData, stepName) => ({
    ...stepData,
    status: createStatusClassName(
      mission.status,
      stepName,
      get(steps, `${mission.status}.order`),
      get(steps, `${stepName}.order`),
    ),
  }))

class TimeLine extends Component {
  render = ({ mission, className } = this.props) => {
    const [draftStep, ...restSteps] = mapSteps(mission) || []
    return (
      <TimeLineWrapper>
        <div className="timeline timeline--summary">
          <div className={`timeline__step ${draftStep.status || ''}`}>
            <span className="timeline__step--first timeline__step-title">
              {draftStep.label}
            </span>
            <i className="timeline__step-marker" />
          </div>
          {restSteps.map((step, i) => (
            <div
              key={i}
              className={`timeline__step ${step.status || ''}`}
              style={{ width: `${100 / restSteps.length}%` }}
            >
              <span className="timeline__step-title">{step.label}</span>
              <i className="timeline__step-marker" />
            </div>
          ))}
        </div>
      </TimeLineWrapper>
    )
  }
}

TimeLine.propTypes = {
  mission: PropTypes.object.isRequired,
}

export { TimeLine }



// WEBPACK FOOTER //
// ./src/Containers/Mission/Header/TimeLine/index.js